/**
 * 我的业绩
 */
<template>
  <div style="margin-top: 20px;">
    <!-- 左边导航 -->
    <div style="font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
      <div class="mouse" v-if="myCaseAuth" :class="{'selected':myCaseAuthCh}" @click="clickLabel('myCase')">我的案件</div>
      <div class="mouse" v-if="caseManageAuth" :class="{'selected':caseManageAuthCh}" @click="clickLabel('caseManage')">案件管理</div>
      <div class="mouse" v-if="settAuditAuth" :class="{'selected':settAuditAuthCh}" @click="clickLabel('settAudit')">结算审核</div>
      <div class="mouse" v-if="historyCaseAuth" :class="{'selected':historyCaseAuthCh}" @click="clickLabel('historyCase')">历史案件</div>
    </div> 
    <!-- 右侧按钮 -->
    <div style="float: right;display: flex;">
      <el-button v-no-more-click size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
      <el-button size="small" icon="el-icon-plus" class="clue-btn" @click="handleAddCase">新增案件</el-button>
      <el-button v-if="myCaseAuthCh" size="small" class="clue-btn" @click="settCaseCheck()" title="勾选需要本月结算的案件,提交审核">结算</el-button>
      <el-button v-if="settAuditAuthCh" size="small" class="clue-btn" title="勾选多个案件批量审核">审核</el-button>
      <el-button v-if="distributeCaseAuth&&caseManageAuthCh" size="small" icon="el-icon-male" class="clue-btn" @click="handleDistributeCase">分配</el-button>
      <el-button v-if="caseExportAuth&&caseManageAuthCh" size="small" icon="el-icon-top" class="clue-btn" @click="handleImportCase">案件导入</el-button>
      <el-button v-if="caseDownloadAuth&&historyCaseAuthCh" size="small" icon="el-icon-bottom" class="clue-btn" @click="caseDownloadSearch">案件下载</el-button>
      <el-button size="small" icon="el-icon-delete" class="clue-btn" @click="delCase">删除</el-button>
    </div>
    <!-- 业绩统计 -->
    <div class="fee-content" v-if="myCaseAuthCh">
      <div class="fee-item"><span class="fee-title">当前月份</span><span class="fee-v">8</span></div>
      <div class="fee-item"><span class="fee-title">年度总费</span><span class="fee-v">{{ totalFee }}</span></div>
      <div class="fee-item"><span class="fee-title">本月总费</span><span class="fee-v">{{ totalFee }}</span></div>
      <div class="fee-item"><span class="fee-title">本月代理费</span><span class="fee-v">{{ proxyFee }}</span></div>
      <div class="fee-item"><span class="fee-title">本月A类代理费</span><span class="fee-v">{{ aProxyFee }}</span></div>
    </div>
    <div class="fee-content" v-if="!myCaseAuthCh">
      <div class="fee-item"><span class="fee-title">总费</span><span class="fee-v">{{ totalFee }}</span></div>
      <div class="fee-item"><span class="fee-title">代理费</span><span class="fee-v">{{ proxyFee }}</span></div>
      <div class="fee-item"><span class="fee-title">A类代理费</span><span class="fee-v">{{ aProxyFee }}</span></div>
    </div>
    <!-- 顶部搜索框 -->
    <div>
      <el-form :inline="true" :model="formInline">
        <el-form-item label="关键词" style="width: 320px;">
          <el-input size="small" v-model="formInline.search_value" placeholder="请输入关键词" clearable style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item label="案件状态" style="width: 320px;">
          <el-select size="small" v-model="formInline.status" placeholder="请选择" clearable>
            <el-option v-for="type in caseStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算状态" style="width: 320px;">
          <el-select size="small" v-model="formInline.settStatus" placeholder="请选择" clearable>
            <el-option v-for="type in settStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成时间" class="clueDatePicker" style="width: 320px;">
              <el-date-picker
                v-model="searchDateValue"
                @change="getSearchDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00',  '23:59:59']"
                style="width: 250px;">
              </el-date-picker>
          </el-form-item>
          <el-button v-no-more-click size="small" icon="el-icon-search" class="clue-btn">查询</el-button>
      </el-form>
    </div>
    <!-- 我的案件列表 -->
     <div v-if="myCaseAuthCh">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <el-table-column prop="case_no" align="center" label="案卷号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_item" align="center" label="申请事项" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="click-btn" title="查看案件详情" @click="handleCasesInfoForMy(scope.$index, scope.row)">{{ scope.row.apply_item }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="顾问" width="60" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="status" align="center" label="案件状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == '已完成'" style="color: #FC5531;">{{ scope.row.status }}</span>
            <span v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sett" align="center" label="结算状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span >{{ scope.row.sett }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="apply_number" align="center" label="申请号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_date" align="center" label="申请日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="entrust" align="center" label="委托事宜" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="total_cost" align="center" label="费用" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="click-btn" title="查看案件详情" @click="handleCasesInfoForMy(scope.$index, scope.row)">{{ scope.row.total_cost }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="complete_date" align="center" label="完成日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_desc" align="center" label="备注" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="agent_name" align="center" label="实务" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="inventor" align="center" label="发明人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_type" align="center" label="业绩类型" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="report" align="center" label="上报端口" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加日期" width="90" show-overflow-tooltip>
        </el-table-column>
      </el-table>
     </div>
    <!-- 案件管理列表 -->
     <div v-if="caseManageAuthCh">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <el-table-column prop="case_no" align="center" label="案卷号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_item" align="center" label="申请事项" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="click-btn" title="查看案件详情" @click="handleCasesInfo(scope.$index, scope.row)">{{ scope.row.apply_item }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="顾问" width="60" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="status" align="center" label="案件状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == '已完成'" style="color: #FC5531;">{{ scope.row.status }}</span>
            <span v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sett" align="center" label="结算状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span >{{ scope.row.sett }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="apply_number" align="center" label="申请号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_date" align="center" label="申请日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="entrust" align="center" label="委托事宜" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="total_cost" align="center" label="费用" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="click-btn" title="查看案件详情" @click="handleCasesInfo(scope.$index, scope.row)">{{ scope.row.total_cost }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="complete_date" align="center" label="完成日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_desc" align="center" label="备注" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="agent_name" align="center" label="实务" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="inventor" align="center" label="发明人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_type" align="center" label="业绩类型" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="report" align="center" label="上报端口" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加日期" width="90" show-overflow-tooltip>
        </el-table-column>
      </el-table>
     </div>
     <!-- 结算审核列表 -->
     <div v-if="settAuditAuthCh">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <el-table-column prop="case_no" align="center" label="案卷号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_item" align="center" label="申请事项" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="click-btn" title="查看案件详情" @click="handleCasesInfo(scope.$index, scope.row)">{{ scope.row.apply_item }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="顾问" width="60" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="status" align="center" label="案件状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == '已完成'" style="color: #FC5531;">{{ scope.row.status }}</span>
            <span v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sett" align="center" label="结算状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="click-btn" title="点击审核" @click="showSettAudit(scope.$index, scope.row)">{{ scope.row.sett }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="apply_number" align="center" label="申请号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_date" align="center" label="申请日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="entrust" align="center" label="委托事宜" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="total_cost" align="center" label="费用" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="click-btn" title="查看案件详情" @click="handleCasesInfo(scope.$index, scope.row)">{{ scope.row.total_cost }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="complete_date" align="center" label="完成日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_desc" align="center" label="备注" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="agent_name" align="center" label="实务" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="inventor" align="center" label="发明人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_type" align="center" label="业绩类型" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="report" align="center" label="上报端口" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加日期" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="showSettAudit(scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
     </div>
    <!-- 历史案件列表 -->
    <div v-if="historyCaseAuthCh">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <el-table-column prop="case_no" align="center" label="案卷号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_item" align="center" label="申请事项" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color: #407AA8;cursor: pointer;" title="查看案件详情" @click="handleCasesInfo(scope.$index, scope.row)">{{ scope.row.apply_item }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="顾问" width="60" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="status" align="center" label="案件状态" width="70" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == '已完成'" style="color: #FC5531;">{{ scope.row.status }}</span>
            <span v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="apply_number" align="center" label="申请号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="apply_date" align="center" label="申请日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="entrust" align="center" label="委托事宜" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="total_cost" align="center" label="费用" title="点击查看详情" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="complete_date" align="center" label="完成日" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_desc" align="center" label="备注" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="agent" align="center" label="实务" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="inventor" align="center" label="发明人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_type" align="center" label="业绩类型" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="report" align="center" label="上报端口" width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加日期" width="90" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 案件导入 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="importFormVisible" width="50%" @click="closeDialog('importForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcelCase
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx或xls文件，且不超过10M</div>
                </el-upload>
                <div style="color: #551A8B;">上传前请检查委托方(客户)只能有一个，多余需要删除，且必须已经录入客户表中,客户匹配失败会导入失败</div>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>
    
    <!-- <div class="rightDrawer" @click="handleDrawerOpen">
      《《
    </div> -->
    <el-drawer 
    :visible.sync="drawer" 
    :direction="direction" 
    :before-close="handleDrawerClose" 
    size="360px" 
    title="条件查询" 
    :show-close="false"
    :wrapperClosable="true"
    class="searchDrawer" 
    >
      <div style="margin-left: 20px;">
          <el-form :inline="true" :model="formInline">
            <el-form-item label="模糊搜索" style="width: 320px;">
              <el-input size="small" v-model="formInline.search_value" placeholder="请输入客户名称" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="所属商务" style="width: 320px;">
              <el-select size="small" v-model="formInline.admin_id" placeholder="请选择" filterable clearable style="width: 250px;">
                <el-option v-for="type in searchSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属客户" style="width: 320px;">
              <el-select size="small" v-model="formInline.customer_id" placeholder="请选择" filterable clearable style="width: 250px;">
                <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="委托事宜" style="width: 320px;">
               <el-select size="small" v-model="formInline.entrust" placeholder="请选择" filterable clearable style="width: 250px;">
                  <el-option v-for="type in entrusts" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="案件状态" style="width: 320px;">
               <el-select size="small" v-model="formInline.status" placeholder="请选择" clearable style="width: 250px;">
                  <el-option v-for="type in caseStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="案件类型" style="width: 320px;">
              <el-select size="small" v-model="formInline.case_type" placeholder="请选择" clearable style="width: 250px;">
                  <el-option v-for="type in caseSearchType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型" style="width: 320px;">
              <el-select size="small" v-model="formInline.customer_type" placeholder="请选择" clearable style="width: 250px;">
                  <el-option v-for="type in customerSearchType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户来源" style="width: 320px;">
              <el-select size="small" v-model="formInline.origin" placeholder="请选择" clearable style="width: 250px;">
                  <el-option v-for="type in originSearch" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上报端口" style="width: 320px;">
              <el-select size="small" v-model="formInline.report" placeholder="请选择" clearable style="width: 250px;">
                  <el-option v-for="type in reportSearch" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="完成时间" class="clueDatePicker" style="width: 320px;">
               <el-date-picker
                  v-model="searchDateValue"
                  @change="getSearchDate"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  unlink-panels
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00',  '23:59:59']"
                  style="width: 250px;">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="添加时间" class="clueDatePicker" style="width: 320px;">
               <el-date-picker
                  v-model="searchAddDateValue"
                  @change="getSearchAddDate"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  unlink-panels
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00',  '23:59:59']"
                  style="width: 250px;">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="searchCase">查询</el-button>
              <el-button type="warning" size="small" @click="resetSearch">重置</el-button>
              <el-button type="danger" size="small" @click="handleDrawerClose">关闭</el-button>
            </el-form-item>
          </el-form>
      </div>
    </el-drawer>
    <div v-if="infoFormVisible" class="caseInfo">
      <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="infoFormVisible" width="850px" @click="closeDialog('infoForm')" style="text-align: center;">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
          <el-tab-pane name="baseInfo" label="信息展示">
            <el-descriptions class="margin-top" title="基本信息" :column="3" :size="size" border>
            <el-descriptions-item>
              <template slot="label">
                案件名称
              </template>
              {{ caseInfoData.apply_item }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                客户名称
              </template>
              {{ caseInfoData.customer_name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                商务
              </template>
            {{ caseInfoData.admin_name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                申请号
              </template>
              {{ caseInfoData.apply_number }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                申请日
              </template>
              {{ caseInfoData.apply_date }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                案件状态
              </template>
              {{ caseInfoData.status }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                委托事宜
              </template>
              {{ caseInfoData.entrust }}
            </el-descriptions-item>
            <!-- <el-descriptions-item>
              <template slot="label">
                委托事宜
              </template>
              {{ caseInfoData.entrust_action }}
            </el-descriptions-item> -->
            <el-descriptions-item>
              <template slot="label">
                业绩类型
              </template>
              {{ caseInfoData.case_type }}
            </el-descriptions-item>
              <el-descriptions-item>
              <template slot="label">
              备注
              </template>
              {{ caseInfoData.case_desc }}
            </el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="费用信息" :column="3" :size="size" border style="margin-top: 20px;">
              <el-descriptions-item>
                <template slot="label">
                  总费用
                </template>
                {{ caseInfoData.total_cost }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  成本
                </template>
                {{ caseInfoData.cost }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  规费
                </template>
                {{ caseInfoData.fees }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  代理费
                </template>
                {{ caseInfoData.agency_fee }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  收款
                </template>
                {{ caseInfoData.collection }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                </template>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
          <el-tab-pane name="editCase" label="案件编辑" class="editCaseP">
            <el-form label-width="120px" :model="editCaseForm" :rules="caseInfoDataRule" ref="caseInfoData">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="标题" prop="apply_item">
                    <el-input size="small" v-model="editCaseForm.apply_item" auto-complete="off" clearable></el-input>
                  </el-form-item>
                   <el-form-item label="总费" prop="total_cost">
                    <el-input size="small" v-model="editCaseForm.total_cost" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="成本" prop="cost">
                    <el-input size="small" v-model="editCaseForm.cost" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="申请号" prop="apply_number">
                    <el-input size="small" v-model="editCaseForm.apply_number" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="商务" prop="admin_id">
                    <el-select size="small" v-model="editCaseForm.admin_id" placeholder="请选择" filterable clearable style="display: block;" disabled>
                      <el-option v-for="type in searchSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="业务类型" prop="entrust">
                    <el-input size="small" v-model="editCaseForm.entrust" auto-complete="off" clearable></el-input>
                  </el-form-item> -->
                  <!-- <el-form-item label="委托事宜" prop="entrust_id">
                    <el-input size="small" v-model="editCaseForm.entrust_id" auto-complete="off" clearable></el-input>
                  </el-form-item> -->
                  <el-form-item label="委托事宜" prop="entrust">
                  <!-- <el-input size="small" v-model="addCaseForm.entrust" auto-complete="off" clearable></el-input> -->
                  <el-select size="small" v-model="editCaseForm.entrust" placeholder="请选择"  filterable clearable style="display: block;">
                    <el-option v-for="type in entrusts" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                  <!-- <el-form-item label="商务" prop="admin_name">
                    <el-input size="small" v-model="editCaseForm.admin_name" auto-complete="off" clearable></el-input>
                  </el-form-item> -->
                    <el-form-item label="上报端口" prop="report">
                    <el-select size="small" v-model="editCaseForm.report" placeholder="请选择" clearable style="display: block;">
                      <el-option v-for="type in reportSearch" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注" prop="case_desc">
                    <el-input size="small" v-model="editCaseForm.case_desc" auto-complete="off" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- <el-form-item label="客户" prop="customer_name">
                    <el-input size="small" v-model="editCaseForm.customer_name" auto-complete="off" clearable></el-input>
                  </el-form-item> -->
                  <el-form-item label="客户" prop="customer_id">
                    <el-select size="small" v-model="editCaseForm.customer_id" placeholder="请选择" filterable clearable style="display: block;">
                      <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="代理费" prop="agency_fee">
                    <el-input size="small" v-model="editCaseForm.agency_fee" auto-complete="off" clearable></el-input>
                  </el-form-item>
                    <el-form-item label="规费" prop="fees">
                    <el-input size="small" v-model="editCaseForm.fees" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="申请日" prop="apply_date">
                    <el-input size="small" v-model="editCaseForm.apply_date" auto-complete="off" clearable placeholder="格式:2023.06.08"></el-input>
                  </el-form-item>
                  <el-form-item label="发明人" prop="inventor">
                    <el-input size="small" v-model="editCaseForm.inventor" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="业绩类型" prop="case_type">
                    <el-select size="small" v-model="editCaseForm.case_type" placeholder="请选择" clearable style="display: block;">
                      <el-option v-for="type in caseType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="案件状态" prop="status">
                    <el-input size="small" v-model="editCaseForm.status" auto-complete="off" disabled></el-input>
                  </el-form-item>
                  <el-form-item v-if="editCaseForm.status == '已完成'" label="修改理由" prop="reason">
                    <el-input size="small" v-model.trim="editCaseForm.reason" auto-complete="off" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button size="mini" @click="closeCaseIno()" style="float: right;margin-left: 10px;">关闭</el-button>
                <el-button v-if="editCaseForm.status != '已完成'" v-no-more-click size="mini" type="primary" @click="editCaseData" style="float: right;">提交</el-button>
                <el-button v-else v-no-more-click size="mini" type="primary" @click="applyEditCase" style="float: right;">申请</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="caseCollection" label="案件回款">
            <el-row>
               <el-col :span="12" style="border: 1px solid #c6cad2;">
                <div style="height: 400px;overflow-y: auto;">
                  <h4 style="text-align: left;margin-left: 6px;margin-right: 6px;background-color: #f8f8f8;padding: 4px 6px;">历史回款</h4>
                  <div style="text-align: left;padding: 10px 20px;" v-for="(collection,index) in collectionLog" :key="index">
                    <div style="margin-left: 10px;">{{ collection.date}}</div>
                    <div style="margin-left: 20px;margin-top: 10px;" v-for="(obj,i) in collection.list" :key="i">
                      <div style="margin-top: 8px;">实际回款金额：￥{{ obj.collect_money }}</div>
                      <div style="margin-top: 8px;">实际回款日期：{{ obj.collect_date }}</div>
                      <div style="margin-top: 8px;">合同名称：{{ obj.apply_item }}</div>
                      <!-- <div style="margin-top: 8px;">
                        <span>更改回款金额:(若回款金额无误,请勿修改)</span>
                        <div style="margin-top: 6px;">
                          <el-input placeholder="请输入收款金额" style="width: 180px;"></el-input>
                        </div>
                      </div>
                      <div style="margin-top: 8px;">
                        <span>更改回款日期:(若回款日期无误,请勿修改)</span>
                        <div style="margin-top: 6px;">
                          <el-date-picker
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择完成日期"
                                style="width: 180px;">
                          </el-date-picker>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
               </el-col>
               <el-col :span="12" style="border: 1px solid #c6cad2;">
                <div style="height: 400px;overflow-y: auto;">
                  <h4 style="text-align: left;margin-left: 6px;margin-right: 6px;background-color: #f8f8f8;padding: 4px 6px;">案件信息</h4>
                  <div style="text-align: left;margin-left: 20px;">
                    <div>
                      <span>标题：</span>
                      <span>{{ caseInfoData.apply_item }}</span>
                    </div>
                    <div style="margin-top: 10px;">
                      <span>客户名称：</span>
                      <span>{{ caseInfoData.customer_name }}</span>
                    </div>
                    <div style="margin-top: 10px;">
                      <span>总费/已收费：</span>
                      <span>￥{{ caseInfoData.total_cost }}/￥{{ caseInfoData.collection }}</span>
                    </div>
                    <div v-if="caseInfoData.status != '已完成'">
                      <div style="margin-top: 10px;">收款金额：<span style="color: #FF5050;font-size: 10px;">（注：回收全款后须提交申请才能修改案件信息）</span></div>
                      <div style="margin-top: 10px;margin-bottom: 10px;">
                        <el-input v-model.trim="collectionForm.collect_money" @input="getCollectMoney($event)" placeholder="请输入收款金额" style="width: 180px;" clearable></el-input>
                      </div>
                      <div style="margin-bottom: 10px;">
                        <div>收款日期：</div>
                        <div style="margin-top: 10px;">
                          <el-date-picker
                              v-model="collectionForm.collect_date"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择收款日期"
                              :picker-options="pickerOptions"
                              style="width: 180px;">
                            </el-date-picker>
                        </div>
                      </div>
                      <div style="margin-bottom: 10px;" v-if="isShowCpmplete&&caseInfoData.status!='已完成'">
                        <div>完成日期：</div>
                        <div style="margin-top: 10px;">
                          <el-date-picker
                              v-model="collectionForm.complete_date"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择完成日期"
                              :picker-options="pickerOptions"
                              style="width: 180px;">
                            </el-date-picker>
                        </div>
                      </div>
                    </div>
                    <div v-if="caseInfoData.status == '已完成'">
                      <div style="margin-top: 10px;">完成日期：{{ caseInfoData.complete_date }}</div>
                      <div style="margin-top: 10px;">
                        <div>更改完成日期:（若完成日期无误，请勿修改）</div>
                        <div style="margin-top: 10px;">
                            <el-date-picker
                              v-model="collectionForm.complete_date"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择完成日期"
                              :picker-options="pickerOptions"
                              style="width: 180px;">
                            </el-date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               </el-col>
            </el-row>
            <div style="margin-top: 10px;">
              <el-button style="float: right;margin-left: 10px;" @click="closeCaseIno()">关闭</el-button>
              <el-button type="primary" v-if="caseInfoData.status == '已完成'" style="float: right;">申请</el-button>
              <el-button type="primary" v-if="caseInfoData.status != '已完成'" style="float: right;" @click="addCollection()">提交</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>

    <!-- 案件新增页面 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="addCaseFormVisible" width="850px" @click="closeDialog('addCaseForm')" style="text-align: center;">
      <div class="editCaseP">
        <el-form label-width="120px" :model="addCaseForm" :rules="addCaseFormRule" ref="addCaseForm">
            <el-row>
              <el-col :span="12">
                <el-form-item label="案件名称" prop="apply_item">
                  <el-input size="small" v-model.trim="addCaseForm.apply_item" auto-complete="off" clearable></el-input>
                </el-form-item>
                  <el-form-item label="总费" prop="total_cost">
                  <el-input size="small" v-model.trim="addCaseForm.total_cost" auto-complete="off" clearable></el-input>
                </el-form-item>
                <el-form-item label="成本" prop="cost">
                  <el-input size="small" v-model.trim="addCaseForm.cost" auto-complete="off" clearable></el-input>
                </el-form-item>
                <el-form-item label="申请号" prop="apply_number">
                  <el-input size="small" v-model.trim="addCaseForm.apply_number" auto-complete="off" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="业务类型" prop="entrust">
                  <el-select size="small" v-model="addCaseForm.entrust" placeholder="请选择"  filterable clearable style="display: block;">
                    <el-option v-for="type in entrusts" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="委托事宜" prop="entrust_id">
                  <!-- <el-input size="small" v-model="addCaseForm.entrust" auto-complete="off" clearable></el-input> -->
                  <el-select size="small" v-model="addCaseForm.entrust" placeholder="请选择"  filterable clearable style="display: block;">
                    <el-option v-for="type in entrusts" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="业绩类型" prop="case_type">
                  <el-select size="small" v-model="addCaseForm.case_type" placeholder="请选择" clearable style="display: block;">
                    <el-option v-for="type in caseType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户" prop="customer_id">
                  <el-select size="small" v-model="addCaseForm.customer_id" placeholder="请选择" filterable clearable style="display: block;">
                    <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="代理费" prop="agency_fee">
                  <el-input size="small" v-model.trim="addCaseForm.agency_fee" auto-complete="off" clearable></el-input>
                </el-form-item>
                  <el-form-item label="规费" prop="fees">
                  <el-input size="small" v-model.trim="addCaseForm.fees" auto-complete="off" clearable></el-input>
                </el-form-item>
                <el-form-item label="申请日" prop="apply_date">
                  <el-input size="small" v-model.trim="addCaseForm.apply_date" auto-complete="off" clearable placeholder="格式:2023.06.08"></el-input>
                </el-form-item>
                <!-- <el-form-item label="委托事宜" prop="entrust_action">
                  <el-input size="small" v-model.trim="addCaseForm.entrust_action" auto-complete="off" clearable></el-input>
                </el-form-item> -->
                <el-form-item label="发明人" prop="inventor">
                  <el-input size="small" v-model.trim="addCaseForm.inventor" auto-complete="off" clearable></el-input>
                </el-form-item>
                <el-form-item label="上报端口" prop="report">
                  <el-select size="small" v-model="addCaseForm.report" placeholder="请选择" filterable clearable style="display: block;">
                    <el-option v-for="type in reportSearch" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
                <el-form-item label="备注" prop="case_desc">
                  <el-input size="small" v-model.trim="addCaseForm.case_desc" auto-complete="off" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="mini" @click="closeAddCase()" style="float: right;margin-left: 10px;">关闭</el-button>
                  <el-button size="mini" type="primary" @click="addCaseData('addCaseForm')" style="float: right;">提交</el-button>
                </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 案件分配界面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="distributeVisible" width="850px">
        <!-- 下拉框选择分配商务 -->
        <el-form :inline="true" :model="distributeForm">
          <el-form-item label="分配客户" style="width: 320px;">
              <el-select size="small" v-model="distributeForm.customer_id" placeholder="请选择" filterable clearable style="width: 250px;" @change="getDistributeName">
                <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <!-- 勾选客户列表 -->
        <el-table size="small" :data="distributeCheckData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
          <el-table-column prop="apply_item" align="center" label="申请事项" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="admin_name" align="center" label="顾问" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="entrust" align="center" label="委托事宜" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" width="90">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delDistributeCus(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 确认分配 -->
        <el-form>
          <el-form-item>
            <el-button type="info" size="small" @click="closeDistribute" style="float: right;margin-left: 10px;margin-top: 10px;">关闭</el-button>
            <el-button type="primary" size="small" @click="commitDistribute" style="float: right;margin-top: 10px;">确认</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

    <!-- 我的案件详情&编辑弹窗 -->
    <div v-if="infoFormVisibleForMy" class="caseInfo">
      <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="infoFormVisibleForMy" width="850px" @click="closeDialog('infoForm')" style="text-align: center;">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
          <el-tab-pane name="baseInfo" label="信息展示">
            <el-descriptions class="margin-top" title="基本信息" :column="3" :size="size" border>
            <el-descriptions-item>
              <template slot="label">
                案件号
              </template>
              {{ myCaseInfoData.case_no }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                案件名称
              </template>
              {{ myCaseInfoData.apply_item }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                客户名称
              </template>
              {{ myCaseInfoData.customer_name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                顾问
              </template>
            {{ myCaseInfoData.admin_name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                申请号
              </template>
              {{ myCaseInfoData.apply_number }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                申请日
              </template>
              {{ myCaseInfoData.apply_date }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                案件状态
              </template>
              {{ myCaseInfoData.status }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                委托事宜
              </template>
              {{ myCaseInfoData.entrust }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                业绩类型
              </template>
              {{ myCaseInfoData.case_type }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                结算状态
              </template>
              {{ myCaseInfoData.sett }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                实务
              </template>
              {{ myCaseInfoData.agent_name }}
            </el-descriptions-item>
              <el-descriptions-item>
              <template slot="label">
              备注
              </template>
              {{ myCaseInfoData.case_desc }}
            </el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="费用信息" :column="3" :size="size" border style="margin-top: 20px;">
              <el-descriptions-item>
                <template slot="label">
                  总费用
                </template>
                {{ myCaseInfoData.total_cost }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  成本
                </template>
                {{ myCaseInfoData.cost }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  规费
                </template>
                {{ myCaseInfoData.fees }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  代理费
                </template>
                {{ myCaseInfoData.agency_fee }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  收款
                </template>
                {{ myCaseInfoData.collection }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                </template>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
          <el-tab-pane name="editCase" label="案件编辑" class="editCaseP">
            <el-form label-width="120px" :model="myEditCaseForm" :rules="caseInfoDataRule" ref="caseInfoData">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="标题" prop="apply_item">
                    <el-input size="small" v-model="myEditCaseForm.apply_item" auto-complete="off" clearable></el-input>
                  </el-form-item>
                   <el-form-item label="总费" prop="total_cost">
                    <el-input size="small" v-model="myEditCaseForm.total_cost" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="成本" prop="cost">
                    <el-input size="small" v-model="myEditCaseForm.cost" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="申请号" prop="apply_number">
                    <el-input size="small" v-model="myEditCaseForm.apply_number" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="商务" prop="admin_id">
                    <el-select size="small" v-model="myEditCaseForm.admin_id" placeholder="请选择" filterable clearable style="display: block;" disabled>
                      <el-option v-for="type in searchSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="委托事宜" prop="entrust">
                  <el-select size="small" v-model="myEditCaseForm.entrust" placeholder="请选择"  filterable clearable style="display: block;">
                    <el-option v-for="type in entrusts" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                    <el-form-item label="上报端口" prop="report">
                    <el-select size="small" v-model="myEditCaseForm.report" placeholder="请选择" clearable style="display: block;">
                      <el-option v-for="type in reportSearch" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注" prop="case_desc">
                    <el-input size="small" v-model="myEditCaseForm.case_desc" auto-complete="off" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户" prop="customer_id">
                    <el-select size="small" v-model="myEditCaseForm.customer_id" placeholder="请选择" filterable clearable style="display: block;">
                      <el-option v-for="type in searchCustomer" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="代理费" prop="agency_fee">
                    <el-input size="small" v-model="myEditCaseForm.agency_fee" auto-complete="off" clearable></el-input>
                  </el-form-item>
                    <el-form-item label="规费" prop="fees">
                    <el-input size="small" v-model="myEditCaseForm.fees" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="申请日" prop="apply_date">
                    <el-input size="small" v-model="myEditCaseForm.apply_date" auto-complete="off" clearable placeholder="格式:2023.06.08"></el-input>
                  </el-form-item>
                  <el-form-item label="发明人" prop="inventor">
                    <el-input size="small" v-model="myEditCaseForm.inventor" auto-complete="off" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="业绩类型" prop="case_type">
                    <el-select size="small" v-model="myEditCaseForm.case_type" placeholder="请选择" clearable style="display: block;">
                      <el-option v-for="type in caseType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="案件状态" prop="status">
                    <el-input size="small" v-model="myEditCaseForm.status" auto-complete="off" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="结算状态" prop="sett">
                    <el-input size="small" v-model="myEditCaseForm.sett" auto-complete="off" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button size="mini" @click="closeCaseInfoForMy()" style="float: right;margin-left: 10px;">关闭</el-button>
                <el-button v-if="myEditCaseForm.sett == '未结算'" v-no-more-click size="mini" type="primary" @click="editCaseDataForMy()" style="float: right;">提交</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>

    <!-- 结算审核页面（单个） -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="settAuditVisible" width="850px">
      <div v-if="auditDetail">
        <el-descriptions title="案件信息" :column="3" border>
          <el-descriptions-item label="案卷号">{{ auditDetail.case_no }}</el-descriptions-item>
          <el-descriptions-item label="客户名称">{{ auditDetail.customer_name }}</el-descriptions-item>
          <el-descriptions-item label="商务">{{ auditDetail.admin_name }}</el-descriptions-item>
          <el-descriptions-item label="已收款">{{ auditDetail.total_collection }}</el-descriptions-item>
          <el-descriptions-item label="预计提成">{{ auditDetail.total_commission }}</el-descriptions-item>
          <el-descriptions-item label="当前步骤"></el-descriptions-item>
        </el-descriptions>
        <el-form label-width="100px" style="margin-top:20px;">
          <el-form-item label="审核意见">
            <el-input type="textarea" v-model="settAudit.audit_remark" placeholder="请输入审核意见"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right;">
          <el-button @click="settAuditVisible = false">取消</el-button>
          <el-button type="danger" @click="submitAudit(2)">驳回</el-button>
          <el-button type="success" @click="submitAudit(1)">通过</el-button>
        </div>
      </div>
    </el-dialog>


  </div>
  
</template>

<script>
import { 
getCaseList, 
webUrl, 
getAuthAdmin, 
getAuthCustomer,
editCaseData,
getCaseCollection,
addCollection,
addCaseData,
delCaseCheck,
downloadSearchCase,
getEntrustList,
getCasePortList,
addApplyCase,
distributeCheckCase,
myCaseList,
caseManageList,
settAuditList,
applySett,
audit,
editMyCaseData
} from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制案件编辑页面显示与隐藏
      importFormVisible: false, //控制案件导入页面显示与隐藏
      addCaseFormVisible: false, //控制新增案件页面显示与隐藏
      collectionFormVisible: false, //控制回款页面显示与隐藏
      infoFormVisible: false, //控制案件详情页面显示与隐藏
      isShowCpmplete: false, //控制案件回款完成日期是否显示
      distributeVisible: false, //控制案件分配页面显示与隐藏
      infoFormVisibleForMy: false, //控制我的案件详情页面弹窗
      settAuditVisible: false,

      // 权限开始
      caseDownloadAuth: false,
      caseExportAuth: false,
      distributeCaseAuth: false,
      myCaseAuth: true,
      myCaseAuthCh: true,
      caseManageAuth: false,
      caseManageAuthCh: false,
      historyCaseAuth: false,
      historyCaseAuthCh: false,
      settAuditAuth: false,
      settAuditAuthCh: false,
      // 权限结束

      title: '预览',
      editCaseForm: {
        id: '',
        apply_item: '',
        apply_date: '',
        apply_number: '',
        total_cost: '',
        cost: '',
        agency_fee: '',
        fees: '',
        inventor: '',
        customer_name: '',
        customer_id: '',
        entrust: '',
        entrust_action: '',
        case_type: '',
        admin_id: '',
        admin_name: '',
        report: '',
        case_desc: '',
        reason: ''
      },
      addCaseForm: {
        apply_item: '',
        apply_date: '',
        apply_number: '',
        customer_id: '',
        total_cost: '',
        cost: '',
        agency_fee: '',
        fees: '',
        entrust: '',
        report: '',
        case_desc: '',
        inventor: '',
        case_type: ''
      },
      myEditCaseForm: {},
      collectionForm: {
        case_id: '',
        total_cost: '',
        collection: '',
        collect_money: '',
        collect_date: '',
        complete_date: ''
      },
      formInline: {
        page: 1,
        ps: 10,
        entrust: '',
        customer_id: '',
        admin_id: '',
        status: '',
        settStatus: '',
        case_type: '',
        customer_type: '',
        origin: '',
        report: '',
        search_value: '',
        startDate: '',
        endDate: '',
        startAddDate: '',
        endAddDate: ''
      },
      distributeForm: {
        customer_id: '',
        customer_name: '',
        ids: ''
      },

      // 业绩统计开始
      totalFee: 0,
      proxyFee: 0,
      aProxyFee: 0,
      // 业绩统计结束

      // 搜索框开始
      drawer: false,
      direction: 'rtl',
      searchDateValue: '',
      searchAddDateValue: '',
      // 搜索框结束

      // 案件详情
      activeName: 'baseInfo',

      multipleSelection: [],
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcelCase:webUrl + '/admin/cases/adminImportCase',

      userparm: [], //搜索权限
      listData: [], //用户数据
      caseInfoData: [], //案件信息数据
      caseEditData: [], //案件编辑数据
      collectionLog: [], //案件回款记录数据

      // 委托事宜
      // entrusts: [
      //   { key: '全部', value: '' },
      //   { key: '发明专利', value: '发明专利' },
      //   { key: '实用新型', value: '实用新型' },
      //   { key: '外观设计', value: '外观设计' },
      //   { key: '涉外专利', value: '涉外专利' },
      //   { key: '商标业务', value: '商标业务' },
      //   { key: '软著登记', value: '软著登记' },
      //   { key: '作品登记', value: '作品登记' },
      //   { key: '其他业务', value: '其他业务' },
      // ],
      // 委托事宜
      entrusts: [],

      // 分配客户列表
      distributeCustomer: [],
      // 勾选的分配案件数据
      distributeCheckData: [],

      // 客户类型(查询)
      customerSearchType: [
        { key: '全部', value: '' },
        { key: '单位', value: '单位' },
        { key: '高校', value: '高校' },
        { key: '自然人', value: '自然人' },
      ],
      // 案件类型(查询)
      caseSearchType: [
        { key: '全部', value: '' },
        { key: 'A', value: 'A' },
        { key: 'B', value: 'B' },
      ],
      caseType: [
        { key: 'A', value: 'A' },
        { key: 'B', value: 'B' },
      ],
      // 客户来源(查询)
      originSearch: [
        { key: '全部', value: '' },
        { key: '自主开发', value: '自主开发' },
        { key: '公司分配', value: '公司分配' },
        { key: '渠道合作', value: '渠道合作' },
        { key: '客户介绍', value: '客户介绍' },
      ],
      // 上报端口(查询)
      reportSearch: [],
      // 案件状态(查询)
      caseStatus: [
        { key: '全部', value: '' },
        { key: '立案', value: '立案' },
        { key: '撰写', value: '撰写' },
        { key: '定稿', value: '定稿' },
        { key: '受理', value: '受理' }
      ],
      // 结算状态(查询)
      settStatus: [
        { key: '全部', value: '' },
        { key: '未结算', value: '未结算' },
        { key: '审核中', value: '审核中' },
        { key: '已结算', value: '已结算' }
      ],
      // 结算审核
      settAudit: {
        applyId: '',
        audit_status: '',
        audit_remark: '',
        apply_item: '',
        customer_name: '',
        customer_id: '',

      },
      // 结算审核案件详情
      auditDetail: [],
      // 日期选择器参数
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
      // 商务列表(查询)
      searchSeller: [],
      // 商务列表(编辑)
      editSeller: [],
      // 客户列表(查询)
      searchCustomer: [],
      // 客户列表(编辑)
      editCustomer: [],
      size: '',
      caseInfoDataRule: {
        apply_item:[{ required: true, message: '请输入申请事项', trigger: 'blur' }],
        customer_id:[{ required: true, message: '请输入客户', trigger: 'blur' }],
        total_cost:[{ required: true, message: '请输入总费用', trigger: 'blur' }],
      },
      addCaseFormRule: {
        apply_item: [{ required: true, message: '请输入案件名称',trigger: 'blur' }],
        total_cost: [{ required: true, message: '请输入总费用',trigger: 'blur' }],
        report: [{ required: true, message: '请选择上报端口',trigger: 'blur' }],
        entrust: [{ required: true, message: '请选择委托事宜',trigger: 'blur' }],
        // entrust_id: [{ required: true, message: '请选择委托事宜',trigger: 'blur' }],
        customer_id: [{ required: true, message: '请选择客户',trigger: 'blur' }],
        case_type: [{ required: true, message: '请选择业绩类型',trigger: 'blur' }],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
    if(btnAuth.includes("caseDownloadAuth")){
      this.caseDownloadAuth = true
    }
    if(btnAuth.includes("caseExportAuth")){
      this.caseExportAuth = true
    }
    if(btnAuth.includes("distributeCaseAuth")){
      this.distributeCaseAuth = true
    }
    if(btnAuth.includes("myCaseAuth")){
      this.myCaseAuth = true
    }
    if(btnAuth.includes("caseManageAuth")){
      this.caseManageAuth = true
    }
    if(btnAuth.includes("historyCaseAuth")){
      this.historyCaseAuth = true
    }
    if(btnAuth.includes("settAuditAuth")){
      this.settAuditAuth = true
    }
    this.getMyCaseListData()
    this.getSellerSelectData()
    this.getCustomerSelectData()
    this.getEntrustData()
    this.getCasePortData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.importFormVisible = false
          this.getManageCaseDataList()
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }
    }, 
    // 视频上传oss 结束

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      // this.getdata(this.formInline)
      if(this.myCaseAuthCh == true){
        this.getMyCaseListData()
      }
      if(this.caseManageAuthCh == true){
        this.getManageCaseDataList()
      }
      if(this.historyCaseAuthCh == true){
        this.getCaseListData()
      }
      if(this.settAuditAuthCh == true){
        this.getSettAuditData()
      }   
      // this.getCaseListData()
    },
    // label切换
    clickLabel(label) {
      this.formInline.page = 1
      if(label == 'myCase'){
        this.myCaseAuthCh = true;
        this.caseManageAuthCh = false;
        this.historyCaseAuthCh = false;
        this.settAuditAuthCh = false;
        this.getMyCaseListData()
      }else if(label == 'caseManage'){
        this.myCaseAuthCh = false;
        this.caseManageAuthCh = true;
        this.historyCaseAuthCh = false;
        this.settAuditAuthCh = false;
        this.getManageCaseDataList()
      }else if(label == 'historyCase'){
        this.myCaseAuthCh = false;
        this.caseManageAuthCh = false;
        this.historyCaseAuthCh = true;
        this.settAuditAuthCh = false;
        this.getCaseListData()
      }else if(label == 'settAudit'){
        this.myCaseAuthCh = false;
        this.caseManageAuthCh = false;
        this.historyCaseAuthCh = false;
        this.settAuditAuthCh = true;
        this.getSettAuditData()
      }
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getCaseListData()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 查询案件列表
    getCaseListData() {
      this.loading = true
      getCaseList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.listData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.totalFee = res.data.totalFee
            this.proxyFee = res.data.proxyFee
            this.aProxyFee = res.data.aProxyFee
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 查询我的案件列表
    getMyCaseListData() {
      this.loading = true
      myCaseList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.listData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 查询结算审核申请列表
    getSettAuditData() {
      this.loading = true
      settAuditList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.listData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 查询管理案件列表
    getManageCaseDataList() {
      this.loading = true
      caseManageList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.listData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 案件下载
    caseDownloadSearch() {
      this.$confirm('确定下载满足条件的案件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        downloadSearchCase(this.formInline)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: '下载成功!'
            }) 
            window.location.href = res.data.url
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 案件结算提交审核
    settCaseCheck() {
      let checks = this.multipleSelection;
      let that = this
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据!'
        })
        return false
      }
      // 收集全部错误信息
      const errorMsgList = [];
      for (const o of checks) {
        // 判断状态,已结算和结算中的不能再次提交
        if (o.sett !== '未结算') {
          errorMsgList.push(`案件【${o.case_no || ''}】：存在不能结算的案件!`)
          break
        }
        if (o.customer_id == 0) {
          errorMsgList.push(`【${o.customer_name}】未在系统中匹配,请手动匹配!`)
          break
        }
        if (o.case_type === '') {
          errorMsgList.push(`案件【${o.case_no || ''}】：结算业务类型不能为空!请填写AB类`)
          break
        }
      }
      if (errorMsgList.length > 0) {
      this.$message({
          type: 'warning',
          message: errorMsgList[0]
        })
        return false
      }
      // 提交结算申请
      let ids = []
      checks.forEach(function(item,index){
        ids.push(item.id)
      })
      applySett({ids:JSON.stringify(ids)})
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getMyCaseListData()
        }else{
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
      
    },
    // 查询商务列表(搜索栏下拉框)
    getSellerSelectData() {
      getAuthAdmin()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.searchSeller = res.data
        }
      })
    },
    // 查询客户列表(搜索栏下拉框)
    getCustomerSelectData() {
      getAuthCustomer()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.searchCustomer = res.data
        }
      })
    },
    // 监听收款金额框输入变化
    getCollectMoney($collect) {
      let caseInfo = this.caseInfoData
      if((parseInt(caseInfo.collection) + parseInt($collect)) > parseInt(caseInfo.total_cost)){
          this.$message({
            type: 'warning',
            message: '收款金额已超过总费!'
          })
          this.collectionForm.collect_money = ''
          return false
      }
      if((parseInt(caseInfo.collection) + parseInt($collect)) == parseInt(caseInfo.total_cost)){
        this.isShowCpmplete = true
      }else{
        this.isShowCpmplete = false
      }
      console.log(caseInfo)
      console.log($collect)
    },
    // 查看案件详情
    handleCasesInfo(index,row) {
      console.log(row)
      this.title = '案件信息'
      this.activeName = 'baseInfo'
      this.caseInfoData = row
      this.infoFormVisible = true
      this.editCaseForm.id = row.id
      this.editCaseForm.total_cost =row.total_cost
      this.editCaseForm.cost =row.cost
      this.editCaseForm.agency_fee = row.agency_fee
      this.editCaseForm.fees = row.fees
      this.editCaseForm.customer_id = row.customer_id
      this.editCaseForm.customer_name = row.customer_name
      this.editCaseForm.apply_date = row.apply_date
      this.editCaseForm.apply_item = row.apply_item
      this.editCaseForm.apply_number = row.apply_number
      this.editCaseForm.inventor = row.inventor
      this.editCaseForm.entrust = row.entrust
      this.editCaseForm.entrust_action = row.entrust_action
      this.editCaseForm.case_type = row.case_type
      this.editCaseForm.admin_id = row.admin_id
      this.editCaseForm.admin_name = row.admin_name
      this.editCaseForm.case_desc = row.case_desc
      this.editCaseForm.report = row.report
      this.editCaseForm.status = row.status
    },
    // 查看我的案件详情
    handleCasesInfoForMy(index,row){
      this.title = '我的案件信息'
      this.activeName = 'baseInfo'
      this.myCaseInfoData = row
      this.myEditCaseForm = row
      this.infoFormVisibleForMy = true
    },
    // 刷新页面数据
    refreshData() {
      if(this.myCaseAuthCh == true){
        this.getMyCaseListData()
      }
      if(this.caseManageAuthCh == true){
        this.getManageCaseDataList()
      }
      if(this.historyCaseAuthCh == true){
        this.getCaseListData()
      }   
      if(this.settAuditAuthCh == true){
        this.getSettAuditData()
      }  
    },
    // 模糊查询客户(搜索栏下拉框)
    // searchCustomerInput(val) {
    //   consoel.log(val)
    // },
    // 显示案件导入页面
    handleImportCase() {
      this.title = '案件导入'
      this.importFormVisible = true
    },
    // 查询案件委托事宜
    getEntrustData(){
      getEntrustList()
      .then(res=>{
        if(res.code == 200){
          this.entrusts = res.data
        }
      })
    },
    // 查询案件上报端口
    getCasePortData() {
      getCasePortList()
      .then(res=>{
        if(res.code == 200){
          this.reportSearch = res.data
        }
      })
    },
    // 显示案件新增页面
    handleAddCase() {
      this.title = '新增案件'
      this.addCaseForm.apply_item = ''
      this.addCaseForm.apply_number = ''
      this.addCaseForm.apply_date = ''
      this.addCaseForm.customer_id = ''
      this.addCaseForm.total_cost = ''
      this.addCaseForm.cost = ''
      this.addCaseForm.agency_fee = ''
      this.addCaseForm.fees = ''
      this.addCaseForm.entrust = ''
      this.addCaseForm.entrust_action = ''
      this.addCaseForm.report = ''
      this.addCaseForm.inventor = ''
      this.addCaseForm.case_type = ''
      this.addCaseForm.case_desc = ''
      this.addCaseFormVisible = true
    },
    // 下载案件导入模板
    downloadImportExcel() {
      console.log(999)
    },
    // 监听日期选择器值的变化
    getSearchDate() {
      // console.log(this.searchDateValue)
      let dateValue = this.searchDateValue
      if(dateValue){
        this.formInline.startDate = dateValue[0]
        this.formInline.endDate = dateValue[1]
      }else{
        this.formInline.startDate = ''
        this.formInline.endDate = ''
      }
    },
    // 监听日期选择器值的变化(添加时间)
    getSearchAddDate() {
      // console.log(this.searchDateValue)
      let dateValue = this.searchAddDateValue
      if(dateValue){
        this.formInline.startAddDate = dateValue[0]
        this.formInline.endAddDate = dateValue[1]
      }else{
        this.formInline.startAddDate = ''
        this.formInline.endAddDate = ''
      }
    },
    // 搜索案件
    searchCase() {
      this.formInline.page = 1
      this.getCaseListData()
    },
    // 删除案件(勾选删除)
    delCase() {
      let data = this.multipleSelection
      let ids = []
      let isAllow = true
      if(data.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据'
        })
        return false
      }
      this.$confirm('确定删除勾选中的案件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        data.forEach((item,index)=>{
            ids.push(item.id)
        })
        let param = JSON.stringify(ids)
        delCaseCheck({ids: param})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getCaseListData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })

      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 开启搜索框
    handleDrawerOpen() {
      let that = this
      // getSearchSeller()
      // .then(res=>{
      //   if(res.code == 200){
      //     that.searchSeller = res.data
      //   }else{
      //     that.searchSeller = []
      //   }
      // })
      this.drawer = true
    },
    // 关闭搜索框
    handleDrawerClose() {
      this.drawer = false
    },
    resetSearch() {
      this.formInline.page = 1
      this.formInline.ps = 15
      this.formInline.entrust = ''
      this.formInline.customer_id = ''
      this.formInline.admin_id = ''
      this.formInline.status = ''
      this.formInline.case_type = ''
      this.formInline.customer_type = ''
      this.formInline.origin = ''
      this.formInline.report = ''
      this.formInline.search_value = ''
      this.formInline.startDate = ''
      this.formInline.endDate = ''
      this.searchDateValue = ''
      this.formInline.startAddDate = ''
      this.formInline.endAddDate = ''
      this.searchAddDateValue = ''
      this.getCaseListData()
    },
    // 关闭案件详情页面
    closeCaseIno() {
      this.infoFormVisible = false
    },
    // 关闭我的案件详情页面
    closeCaseInfoForMy() {
      this.infoFormVisibleForMy = false
    },
    // 显示回款页面
    handleCaseCollection() {
      let info = this.caseInfoData
      this.infoFormVisible = false
      console.log(info)
    },
    // 显示编辑页面
    handleEditCase() {
      let info = this.caseInfoData
      this.editFormVisible = true
      this.caseEditData = info
    },
    closeEditCase() {
      this.editFormVisible = false
    },
    // 添加案件回款
    addCollection() {
      console.log(this.collectionForm)
      addCollection(this.collectionForm)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){  
          // 回款添加成功
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getCaseListData()
          this.infoFormVisible = false
        }
      })
    },
    // 案件信息编辑
    editCaseData() {
      console.log(this.editCaseForm)
      let status = this.editCaseForm.status
      // if(status == '已完成'){
      //   this.$message({
      //     type: 'warning',
      //     message: '已完成的案件不支持自主修改,请联系管理员!'
      //   })
      //   return false
      // }
      editCaseData(this.editCaseForm)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getCaseListData()
          this.infoFormVisible = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 我的案件信息编辑
    editCaseDataForMy() {
      editMyCaseData(this.myEditCaseForm)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getMyCaseListData()
          this.infoFormVisibleForMy = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 添加案件信息
    addCaseData(addCaseForm) {
      this.$refs[addCaseForm].validate(valid => {
        if(valid){
          addCaseData(this.addCaseForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.addCaseFormVisible = false
              this.getCaseListData()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
        }
      })
    },
    // 案件详情选项卡切换
    handleTabClick(tab, event) {
      let tabName= tab.name
      let case_id = this.caseInfoData.id
      let status = this.caseInfoData.status
      if(tabName == 'caseCollection'){
        // 点击案件回款tab
        this.collectionForm.case_id = case_id
        this.collectionForm.total_cost = this.caseInfoData.total_cost
        this.collectionForm.collection = this.caseInfoData.collection
        this.collectionForm.collect_money = ''
        this.isShowCpmplete = false
        this.collectionForm.collect_date = ''
        this.collectionForm.complete_date = ''
        console.log(case_id)
        if(status == '未收款' || status.length <= 0){
          // console.log('未收款')
          this.collectionLog = []
        }else{
          getCaseCollection({case_id: case_id})
            .then(res=>{
              res = checkLogin(res)
              if(res.code == 200){
                console.log(res)
                this.collectionLog = res.data
              }
            })
        }
      }
    },
    // 关闭新增案件页面
    closeAddCase() {
      this.addCaseFormVisible = false
    },
    // 案件信息修改申请
    applyEditCase() {
      // console.log(this.editCaseForm)
      if(this.editCaseForm.reason.length <= 0){
        this.$message({
          type: 'warning',
          message: '修改理由不能为空!'
        })
        return false
      }
      addApplyCase(this.editCaseForm)
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.infoFormVisible = false
          this.getCaseListData()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })

    },
    // 案件回款信息修改(完成时间)
    applyEditCaseFee() {

    },
    // 点击分配,显示分配页面
    handleDistributeCase() {
      let checks = this.multipleSelection;
      let that = this
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据!'
        })
        return false
      }
      this.title = '案件分配'
      this.distributeCheckData = checks
      this.distributeVisible = true
      console.log(checks)
    },
    // 监听分配客户值变化
    getDistributeName(val) {
      let customer = this.searchCustomer
      let that = this
      customer.forEach(function(item,index){
        if(item.value == val){
          that.distributeForm.customer_name = item.key
        }
      })
    },
    // 提交分配
    commitDistribute() {
      let customer_id = this.distributeForm.customer_id
      let customer_name = this.distributeForm.customer_name
      if(customer_id.length <= 0 || customer_name <= 0){
        this.$message({
          type: 'error',
          message: '分配客户不能为空!'
        })
        return false
      }
      // 确认是否分配
      this.$confirm('确定分配案件到该客户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let idArr = []
        this.distributeCheckData.forEach(function(item,index){
          idArr.push(item.id)
        })
        this.distributeForm.ids = JSON.stringify(idArr)
        distributeCheckCase(this.distributeForm)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.distributeVisible = false
            this.getCaseListData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 关闭客户分配界面
    closeDistribute() {
      this.distributeVisible = false
    },
    // 删除分配页面勾选的数据
    delDistributeCus(index,row) {
      let id = row.id
      let checks = this.distributeCheckData
      if(checks.length == 1){
        this.distributeCheckData = []
        this.distributeVisible = false
        return false
      }
      let newChecks = []
      checks.forEach(function(item,index){
        if(item.id != id){
          newChecks.push(item)
        }
      })
      this.distributeCheckData = newChecks
    },
    // 显示结算审核页面
    showSettAudit(index,row){
      this.title = '结算审核'
      this.settAuditVisible = true
      this.auditDetail = row
    },
    // 关闭编辑、增加弹出框0
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>


<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.clue-btn {
  background-color: #333333;
  color: #FFFFFF;
}
.clue-search {
  margin-left: 20px;
  background-color: #E4E4E4;
}
.clue-search-btn {
  background-color: #333333 !important;
  color: #FFFFFF !important;
  font-weight: 700 !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.u-btn {
  display: none;
}
.mouse {
  cursor: pointer;
  color: #D9D9D9;
  margin-right: 18px;
}
.selected {
  color: #333333;
}
.rightDrawer {
  width: 40px;
  height: 100px;
  background-color: #00C8DF;
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  left: auto;
  right: 0;
  top: 40%;
  z-index: 10;
  color: #FFFFFF;
  text-align: center;
  margin-top: auto;
  line-height: 100px;
  cursor: pointer;
}
.searchDrawer {
  height: 80vh;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 20px 0px 0px 20px;
}
.searchDrawer>>>.el-form-item {
  margin-bottom: 10px;
}
.caseInfo>>>.el-dialog__body {
  border-top: 1px solid #909399 !important;
}
.clueDatePicker>>>.el-range-editor.el-input__inner {
  padding: 1px 4px;
}
.clueDatePicker>>>.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 215px;
  height: 34px;
}
.editCaseP>>>.el-form-item {
  margin-bottom: 14px !important;
}
.fee-content {
  height: 46px;
  line-height: 46px;
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  border: 1px solid #EBEEF5;
}
.fee-item {
  margin: 0px 20px;
}
.fee-title {
  font-weight: 700;
  font-size: 14px;
  color: #333333;
  margin-left: 10px;
}
.fee-v {
  font-size: 18px;
  color: #215ac9;
  font-weight: 700;
  margin-left: 10px;
}
.setSuccess {
  background-color: red !important;
}
.click-btn {
  color: #407AA8;
  cursor: pointer; 
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/crm/score.vue